import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArTN: CultureInfo = {
  name: 'ar-TN',
  displayName: 'Arabic (Tunisia)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-TN',
  parent: CultureInfoAr
};
